export const m = {
  EnterID: "Bấm nhập Tada ID",
  "select-specifications": "Bấm chọn quy cách nạp tiền",
  "check-account": "Đối chiếu tài khoản nạp tiền",
  whatID: "Tada ID là gì?",
  getID: "Nhập Tada ID",
  maskgetID: "Nhập Tada ID",
  "toastTipsPlease-format-error": "Định dạng nhập lỗi",
  "toastTips-no-exist": "ID này không tồn tại",
  toastTipsPlease: "Vui lòng đối chiếu tài khoản nạp tiền",
  "common-problem": "Vấn đề thường gặp",
  "transaction-succeeded": "Giao dịch thành công",
  "transaction-failed": "Giao dịch thất bại",
  "transaction-cancel": "Hủy giao dịch",
  "whether-account":
    "1.Sau khi nạp tiền xong làm thế nào để kiểm tra đã vào tài khoản hay chưa?",
  "answer-whether-account":
    "Sau khi nạp tiền xong có thể vào 【Tôi】 - 【Ví tiền】 trong app để kiểm tra kim cương",
  "no-account":
    "2.Sau khi nạp tiền xong nếu không vào tài khoản thì làm thế nào?",
  "answer-no-account":
    "Vui lòng gửi vấn đề của bạn tại【Tin tức】-【Tin tức chính thức】-【Phản hồi và Hỗ trợ】 trong app, đồng thời cung cấp những thông tin sau đây, chăm sóc khách hàng của chúng tôi sẽ hỗ trợ cho bạn",
  "recharge-money": "1. Số tiền nạp và ID tài khoản",
  "recharge-time": "2. Thời gian và ngày tháng nạp tiền",
  "recharge-shot": "3. Ảnh chụp màn hình nạp tiền thành công",
  "recharge-wrong": "3.Nạp sai tài khoản, số tiền nạp sai làm thế nào",
  "answer-recharge-wrong":
    "Trước khi nhập mật khẩu thanh toán, bạn phải xác nhận lại thông tin về ID tài khoản nạp tiền và số tiền nạp rồi mới tiến hành mua. Số tiền nạp sai không thể trả lại, nạp sai tài khoản bạn có thể thử liên hệ với người dùng có ID đã nhận tiền thực tế, để thỏa thuận với đối phương có trả lại số tiền đã nạp cho bạn hay không.",
  refund: "4.Hoàn tiền",
  "answer-refund":
    "Xin lỗi! Hiện nay Tada không hỗ trợ hoàn tiền với bất kỳ hình thức nào.",
  "buy-enter-link":
    'Mua kim cương có thể thông qua đường link để nạp tiền, <a class="web-link"  href="https://pay.tadachat.info/" >https://pay.tadachat.info</a> sao chép đường link vào trình duyệt điện thoại và mở ra, đi vào giao diện mua, sau khi đối chiếu tài khoản, chọn quy cách tương ứng và sử dụng phương thức thanh toán phù hợp để thanh toán là được ~ Cực nhiều ưu đãi!',
  "buy-notice-a":
    "Chú ý:<a>pay.tadachat.info</a> là trang web mua kim cương chính thức duy nhất của Tada",
  replace: "Thay đổi",
  sureBtn: "xác định",
  "pay-style": "chọn phương thức thanh toán",
  goBack: "Quay lại trang chủ",
  toastTips: "Nhập Tada ID",
  rechargeFAQ_title: "Vấn đề thường gặp",
  PayStatusSuccess_title: "Giao dịch thành công",
  PayStatusFail_title: "Giao dịch thất bại",
  PayStatusCancel_title: "Hủy giao dịch",
  Diamonds_title: "Trang web chính thống nạp kim cương Tada ",
  "buy-notice":
    "Lưu ý pay.Tadachat.info là trang web mua kim cương chính thức duy nhất của Tada. Đối với các yêu cầu dịch vụ khách hàng, vui lòng truy cập [Tin nhắn] - [Tin tức chính thức] - [Phản hồi và trợ giúp]",
  RechargeHelp_title: "Trợ giúp nạp tiền",
  openAPP: "Ứng dụng Tada mở",
  "buy-diamonds-tit": "Mua dịch vụ kim cương",
  description:
    "Trang web chính thống nạp kim cương duy nhất Tada, Tada là một ứng dụng mạng xã hội quốc tế, người dùng trên toàn cầu vượt quá 150 quốc gia và khu vực đang sử dụng Tada ",
  keywords:
    "Nạp Tada, nạp kim cương Tada, nạp chính thống Tada, trang web nạp chính thống Tada",
  payforType: "Şarj yöntemi",
  trueText: "xác định",
  falseText: "hủy",
  alertShowTxt1: "",
  alertShowTxt3: "elmasları şarj etmek için",
  alertShowTxt5: "kullanacağınızdan emin misiniz?",
  EnterIDTip: "Nạp tiền nhanh qua Tada",
  scanLogin:
    "Vì sự riêng tư và bảo mật của tài khoản, vui lòng quét mã để đăng nhập",
  scanTip:
    'Mẹo: Nhấp vào "Quét" ở góc trên bên phải "Trung tâm cá nhân / Động lực" của Tada để quét mã đăng nhập. Đồng thời hỗ trợ đăng nhập bằng cách nhận diện ảnh chụp màn hình mã QR',
  scanVersion:
    "Vui lòng nâng cấp Tada lên phiên bản %s và quét mã để đăng nhập",
  delAccount: "Xóa tài khoản",
  logout: "thoát",

  submit: "đệ trình",
  email_place_holder: "nhập email của bạn",
  contact_email: "Địa chỉ email liên lạc",
  provide_email:
    "Vui lòng cung cấp địa chỉ email của bạn để nhận thông báo thanh toán",
  email_address: "Địa chỉ email",
  reseller: "Người bán lại",
};



// WEBPACK FOOTER //
// ./src/lang/vi.js